export default __webpack_public_path__ + "static/bg-doctor--mobile-929f6d5b4488c811e7f085e88bb9eced.jpg";